import React, { Suspense } from 'react';
import { MEDIA_BREAKPOINTS } from '../../../constants/MEDIA_BREAKPOINTS';
import { ToolbarSkeleton } from './Toolbar.skeleton';
const ToolbarDesktop = React.lazy(async () => await import('./Toolbar.desktop').then(({ ToolbarDesktop }) => ({ default: ToolbarDesktop })));
const ToolbarMobile = React.lazy(async () => await import('./Toolbar.mobile').then(({ ToolbarMobile }) => ({ default: ToolbarMobile })));
export const Toolbar = ({ itemsAPIRef }) => (React.createElement(Suspense, { fallback: React.createElement(ToolbarSkeleton, null) }, MEDIA_BREAKPOINTS.MD_UP.matches
    ? React.createElement(ToolbarDesktop, { itemsAPIRef: itemsAPIRef })
    : React.createElement(ToolbarMobile, { itemsAPIRef: itemsAPIRef })));
